module.exports = __webpack_public_path__ + "static/img/white1.9c96cfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/white1.png
// module id = eT7X
// module chunks = 1